export function actionSetAuthUser(value) {
    return {
        type: 'SET_AUTH_USER',
        value: value
    };
}

export function actionLogout() {
    return {
        type: 'SET_AUTH_USER',
        value: null
    };
}
